import React, { useEffect } from 'react';
import "./App.css";
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import WhatIsVBC from './components/WhatIsVBC';
import WhoWeAre from './components/WhoWeAre';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import { initializeBrevoService } from './services/brevoService';

function App() {
  useEffect(() => {
    // Initialize Brevo service when app loads
    initializeBrevoService().then(success => {
      if (success) {
        console.log('✅ Brevo integration ready');
      } else {
        console.warn('⚠️ Brevo integration failed to initialize');
      }
    });
  }, []);

  return (
    <div className="App">
      <Navigation />
      <main>
        <HeroSection />
        <WhatIsVBC />
        <WhoWeAre />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
